module.exports = __webpack_public_path__ + "static/media/profile-steve-barth.5540776c.jpg";